// @ts-nocheck
import { useEffect } from "react";
import { toast } from "sonner";
import { apiWithGetHeader } from "../service/api";
import { API_SYSTEM_HEALTH_ALERTS } from "../service/url";
import { Storage, getUserAccessToken } from "../utilities/setting";
import { USER_ROLES, BACKEND_API_BASE_URL } from "../utilities/constant";

const POLL_INTERVAL_MS = 30 * 1000;
const AUTO_CLOSE_CRITICAL_MS = 20 * 1000;
const AUTO_CLOSE_WARNING_MS = 15 * 1000;

function useSystemHealthAlerts() {

  useEffect(() => {
    let user;
    try {
      user = JSON.parse(Storage.getItem("user") || "null");
    } catch (e) {
      return undefined;
    }

    if (!user?.id || user.role !== USER_ROLES.SUPERADMIN) return undefined;

    let cancelled = false;
    let timerId = null;

    const showAlerts = (alerts) => {
      (alerts || []).forEach((alert) => {
        if (!alert?.key) return;

        const isCritical = alert.severity === "critical";
        const message = alert.detail ? `${alert.title} — ${alert.detail}` : alert.title;
        const options = {
          id: `system-health-${alert.key}`,
          duration: isCritical ? AUTO_CLOSE_CRITICAL_MS : AUTO_CLOSE_WARNING_MS,
        };

        if (isCritical) toast.error(message, options);
        else toast.warning(message, options);
      });
    };

    const poll = async () => {
      try {
        const resp = await apiWithGetHeader(
          BACKEND_API_BASE_URL,
          {},
          getUserAccessToken()
        ).get(API_SYSTEM_HEALTH_ALERTS, { timeout: 20000 });
        if (cancelled) return;
        showAlerts(resp?.data?.data?.alerts);
      } catch (err) {
        console.error("System health alerts poll failed:", err?.message || err);
      }
    };

    poll();
    timerId = setInterval(() => {
      if (!document.hidden) poll(); // skip in background tabs
    }, POLL_INTERVAL_MS);

    return () => {
      cancelled = true;
      if (timerId) clearInterval(timerId);
    };
  }, []);
}

export default useSystemHealthAlerts;
